const highlights = [
  {
    type: "Leadership",
    title: "Team Leadership at Accenture",
    description:
      "Led a 20+ member team, drove Agile ceremonies, ensured on-time delivery, mentored junior engineers.",
    outcome: "Improved team productivity by 30% and delivery quality.",
    year: "2021–Present",
  },
  {
    type: "Leadership",
    title: "Full-Stack Technical Lead",
    description:
      "Designed and developed scalable applications using Java 8, ReactJS, and Microservices.",
    outcome: "Enhanced performance, reduced latency by 25%.",
    year: "2018–2021",
  },
  {
    type: "Learning",
    title: "Generative AI & React.js",
    description:
      "Currently deepening expertise in Generative AI and advanced React.js to build intelligent, interactive apps.",
    outcome: "Exploring AI integration into enterprise workflows.",
    year: "Ongoing",
  },
  {
    type: "Learning",
    title: "Kubernetes Deployment Strategies",
    description:
      "Hands-on learning of advanced Kubernetes deployment and orchestration strategies.",
    outcome: "Preparing for enterprise-scale microservices management.",
    year: "Ongoing",
  },
];

export {highlights};